module.exports = __webpack_public_path__ + "img/primary-sub-2.d3a7094b.jpg";